import { FC } from 'react';
import { Tooltip } from 'uikit/tooltip/tooltip.component';
import { AppButton, AppButtonProps } from '../button/button.component';

type AppButtonWithTooltipProps = AppButtonProps & {
  tooltip: string;
  disabledTooltip?: boolean;
  hostClassName?: string;
  tooltipClassName?: string;
};

export const AppButtonWithTooltip: FC<AppButtonWithTooltipProps> = ({
  tooltip,
  disabledTooltip,
  hostClassName,
  tooltipClassName,
  ...buttonProps
}) => {
  const { onClick, ...restButtonProps } = buttonProps;

  return (
    <Tooltip text={tooltip} disabled={disabledTooltip} hostStyles={hostClassName} styles={tooltipClassName}>
      <AppButton
        {...restButtonProps}
        onClick={(e) => {
          onClick?.(e);
          e.currentTarget.blur();
        }}
      />
    </Tooltip>
  );
};
